import { render, staticRenderFns } from "./Prescriptions.vue?vue&type=template&id=b226f994&scoped=true"
import script from "./Prescriptions.vue?vue&type=script&lang=js"
export * from "./Prescriptions.vue?vue&type=script&lang=js"
import style0 from "./Prescriptions.vue?vue&type=style&index=0&id=b226f994&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b226f994",
  null
  
)

export default component.exports